//
// Used to avoid React re-render on non-primitive default props
//
const emptyArray = [];

export default emptyArray;
